/**
 *
 * AuthCallToActionModal
 *
 */

import React, { useEffect } from 'react';
import _get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { hideAuthCTAModal } from 'containers/Auth/actions';
import {
  makeSelectAuth,
  makeSelectAuthCTAModalStatus,
  makeSelectProfile,
} from 'containers/Auth/selectors';
import {
  makeSelectClientDetails,
  makeSelectAllowSignIn,
} from 'containers/Main/selectors';
import { getRequiredExtraData } from 'components/SAMLButton/utils';
import ModalContent from './ModalContent';

const AuthCallToActionModal = () => {
  const dispatch = useDispatch();
  const auth = useSelector(makeSelectAuth());
  const profile = useSelector(makeSelectProfile());
  const location = useLocation();
  const history = useHistory();
  const clientDetails = useSelector(makeSelectClientDetails());
  const status = useSelector(makeSelectAuthCTAModalStatus());
  const allowSignIn = useSelector(makeSelectAllowSignIn());
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));

  const finalStatus = allowSignIn && !isXs && status;

  useEffect(() => {
    if (finalStatus && profile.isLoaded && !profile.isEmpty) {
      const isSignUp = Date.now() - auth.createdAt < 5 * 60 * 1000;
      if (
        isSignUp &&
        !_get(clientDetails, 'metadata.hideSubscription') &&
        !_get(profile, 'email')
      ) {
        if (location.pathname !== '/signup/email')
          history.push(`/signup/email?redirect=${location.pathname}`);
      } else if (
        isSignUp &&
        _get(profile, 'providerData.providerId') !== 'password' &&
        getRequiredExtraData(profile).length > 0
      ) {
        if (location.pathname !== '/signup/data')
          history.push(`/signup/data?redirect=${location.pathname}`);
      }
      dispatch(hideAuthCTAModal());
    }
  }, [auth, clientDetails, dispatch, history, location, profile, finalStatus]);

  if (!finalStatus) return null;

  return <ModalContent />;
};

export default AuthCallToActionModal;
